<template>
  <v-badge
    class='badge'
    color="#9fa5b4"
    :value='displayCopiedBadge'
    :content='copiedBadgeLabel'
    :class="{'copied-badge': displayCopiedBadge}"
    left
    offset-x='30px'
    offset-y='3px'
  >
    <div class="centralized-issues-asset-table-cell" :title='getAsset' @click.stop='copyAsset'>
      <span class='centralized-issues-asset-table-cell__asset'>{{ getAsset }}</span>
    </div>
  </v-badge>
</template>

<script>
export default {
  name: 'AssetTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      displayCopiedBadge: false,
    };
  },
  computed: {
    copiedBadgeLabel() {
      return this.$t('copied');
    },
    getAsset() {
      return this.item.asset.replace(/__/g, '.');
    },
  },
  methods: {
    delay(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },
    async copyAsset() {
      const data = this.getAsset;
      await navigator.clipboard.writeText(data);
      this.displayCopiedBadge = true;
      await this.delay(2000);
      this.displayCopiedBadge = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';
.badge {
  max-width: 100%;
  z-index: 10;
  .centralized-issues-asset-table-cell {
    z-index: 4;
    color: var(--text-primary);
    display: flex;
    font-family: $font-family-bold;
    font-size: rem(14);
    font-weight: bold;
    letter-spacing: 0;
    line-height: rem(17);
    flex-direction: column;
    justify-content: center;
    &__asset {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: rem(20);
    }
    &:hover {
      cursor: pointer;
    }
  }
}
</style>

<style lang='scss'>
@import '~@/assets/styles/design-system';
.badge {
  &.copied-badge {
    .v-badge__wrapper {
      .v-badge__badge {
        text-transform: capitalize;
        background: transparent !important;
        border: none !important;
        color: var(--text-secondary);
      }
    }
  }
}
</style>
